import React, { useState } from 'react'

import PropTypes from 'prop-types'
import { Box, IconButton, Typography } from '@material-ui/core'
import { Trash as TrashIcon } from 'react-feather'

import { ConfirmationDialog } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

import useStyles from './styles'
import helpers from 'helpers'

const ResponsibleEmailsTable = ({
  responsibleEmails,
  removeResponsibleEmail,
  initialEmails,
  audit,
  isShow = false,
}) => {
  const [openRemoveUserDialog, setOpenRemoveUserDialog] = useState(false)
  const [userEmailToRemove, setUserEmailToRemove] = useState(null)
  const [loading, setLoading] = useState(null)

  const classes = useStyles()
  const { companySupplier } = useThirdPartyManagementStepper()
  const snackbar = useSnackbar()

  const handleOpenRemoveUser = (email) => {
    if (initialEmails.includes(email)) {
      setUserEmailToRemove(email)
      setOpenRemoveUserDialog(true)
    } else {
      removeResponsibleEmail(email)
    }
  }

  const handleRemoveUser = async () => {
    try {
      setLoading(true)
      const companySupplierAuditUser = audit?.companySupplierAuditUsers?.find(
        (item) => item?.user?.email === userEmailToRemove,
      )

      await service.dponet.suppliers.removeUser({
        companySupplierId: companySupplier?.id,
        companySupplierAuditId: audit?.id,
        companySupplierAuditUserId: companySupplierAuditUser?.id,
      })

      snackbar.open({
        message: 'Usuário removido com sucesso',
        variant: 'success',
      })

      setOpenRemoveUserDialog(false)
      removeResponsibleEmail(userEmailToRemove)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao remover usuário',
        variant: 'error',
      })
    } finally {
      setLoading(false)
      setUserEmailToRemove(null)
    }
  }

  return (
    <Box>
      <Table size="small" noWrap isLoading={loading}>
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell align="left" width="50%">
              E-mail
            </TableCell>
            {!isShow && (
              <TableCell align="right" width="50%">
                Ação
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {responsibleEmails?.length > 0 ? (
            responsibleEmails.map((email, index) => (
              <TableRow key={index}>
                <TableCell align="left">
                  <Box>
                    <Typography variant="subtitle2">{email}</Typography>
                  </Box>
                </TableCell>
                {!isShow && (
                  <TableCell align="right">
                    <IconButton onClick={() => handleOpenRemoveUser(email)}>
                      <TrashIcon size={20} />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} align="left" className={classes.empty}>
                <Typography variant="caption">
                  Nenhum responsável encontrado. Adicione-os.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {openRemoveUserDialog && (
        <ConfirmationDialog
          open={openRemoveUserDialog}
          setOpen={setOpenRemoveUserDialog}
          text="Você tem certeza que deseja remover esse usuário?"
          textButton="Remover"
          actionAcceptButton={handleRemoveUser}
        />
      )}
    </Box>
  )
}

ResponsibleEmailsTable.propTypes = {
  responsibleEmails: PropTypes.array,
  removeResponsibleEmail: PropTypes.func,
  initialEmails: PropTypes.array,
  audit: PropTypes.object,
  isShow: PropTypes.bool,
}

export default ResponsibleEmailsTable
